
import { mapState, mapActions } from 'vuex'
import { SlideYDownTransition } from 'vue2-transitions'
import PinSVG from '~/assets/svg/filter.svg?inline'

export default {
  components: {
    SlideYDownTransition,
    PinSVG,
  },

  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isOpen: this.open,
    }
  },

  computed: {
    ...mapState('resources', ['zip', 'county']),

    counties() {
      return this.$store.getters['general/county']
    },

    computedClass() {
      return {
        'resourceTableFilter--active': this.isOpen,
      }
    },
  },

  methods: {
    ...mapActions('resources', ['setZip', 'setCounty']),

    onFilterClick(event) {
      this.isOpen = !this.isOpen
    },

    onZipInput(event) {
      if (event.length === 5) {
        this.setZip(event)
        this.setCounty('')
        this.isOpen = false
      }
    },

    onClearClick() {
      this.$emit('clear')
      this.setZip('')
      this.setCounty('')
      this.isOpen = false
    },

    onCountyInput(event) {
      this.setZip('')
      this.setCounty(event)
      this.isOpen = false
    },

    onCancelClick(event) {
      this.$emit('clear')
      this.$emit('push-description', false)
      this.isOpen = false
    },
  },
}
